import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { GlobalContext } from "../contexts";
import { firebaseErrorMap, api } from "../config";
import { Grid, Image, Button } from "semantic-ui-react";
import {
  getAuth,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
} from "firebase/auth";
import axios from "axios";

function Register() {
  let navigate = useNavigate();
  const { addToast } = useToasts();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (event, callback) => {
    callback(event.target.value);
  };

  const register = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (loading) {
      return;
    }
    if ([firstName, lastName, email, password, phone].includes("")) {
      return setMessage("Please fill in all fields");
    }
    setLoading(true);
    try {
      const user = await createUserWithEmailAndPassword(
        getAuth(),
        email,
        password
      ); 
      axios.get(
        api +
          `create_user_data?firstName=${firstName}&lastName=${lastName}&phoneNumber=${phone}&token=${await user.user.getIdToken(
            true
          )}`
      );
      setMessage("");
      addToast("Your account has been created!", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (e) {
      const message = firebaseErrorMap[e.code] || e.message;
      setMessage(message);
    }
    setLoading(false);
    console.log(email, password);
  };

  return (
    <div className="container register">
      <h1>Create an account</h1>
      <form className="form">
        <input
          type="text"
          required
          onChange={(e) => handleChange(e, setFirstName)}
          placeholder="First Name"
          maxLength={50}
        />
        <input
          type="text"
          required
          onChange={(e) => handleChange(e, setLastName)}
          placeholder="Last Name"
          maxLength={50}
        />
        <input
          type="text"
          pattern="\d*"
          placeholder="Phone Number"
          maxlength="15"
          onChange={(e) => handleChange(e, setPhone)}
        />

        <input
          type="text"
          required
          onChange={(e) => handleChange(e, setEmail)}
          placeholder="Email"
        />
        <input
          type="password"
          required
          onChange={(e) => handleChange(e, setPassword)}
          placeholder="Password"
        />
        <Button
          disabled={loading}
          loading={loading}
          type="submit"
          id="login-button"
          onClick={register}
        >
          Register
        </Button>
        <div className="response-message">{message}</div>
        <Grid columns={4} divided centered>
          <Grid.Row>
            <Grid.Column style={{display: 'flex', justifyContent: 'center'}}>
              <Link
                href="#"
                to="/login"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Login
              </Link>
            </Grid.Column>
            <Grid.Column  style={{display: 'flex', justifyContent: 'center'}}>
              <Link
                href="#"
                to="/password-reset"
                style={{ color: "white", fontWeight: "bold" }}
              >
                Forgot Password?
              </Link>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </form>
    </div>
  );
}
export default Register;
